import t from '@jetshop/intl';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { styled } from 'linaria/react';
import React, { useMemo } from 'react';
import useHeaderHeight from '../../../r3-lib/hooks/useHeaderHeight';
import { theme } from '../../Theme';
import FilterDrawer from './FilterDrawer';
import FilterButton from './Mobile/FilterButton';
import { SortOrders } from './SortOrders';
// import { ActiveListFilterItem } from './ActiveFilters';
import { ActiveFilters } from './ActiveFilters';
import { Above, Below } from '@jetshop/ui/Breakpoints';

const DrawerWrapper = styled('div')`
  // Flyout
  > div {
    background: ${theme.colors.white};
    top: ${props => props.topPosition}px;
    border-top: 1px solid ${theme.colors.border};
    padding: 20px;
  }
`;

const FilterRow = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  .upper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  ${theme.below.lg} {
    flex-direction: column;
    font-size: 1px;
    margin: 20px;
  }
`;
const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  button {
    margin-bottom: 0;
  }
`;
const ProductNumber = styled('div')`
  color: ${theme.colors.black};
  font-size: 14px;
  line-height: 14px;
  font-family: ${theme.fonts.primary};
  ${theme.below.lg} {
    font-size: 12px;
    line-height: 12px;
  }
`;

const FilterButtonWrapper = styled('div')`
  position: relative;
`;

const SortButtonWrapper = styled('div')`
  position: relative;

  [data-flight-dropdown-button] {
    border: none !important;
    width: 100% !important;
    padding: 10px 10px 10px 0 !important;
    span {
      line-height: 20px;
      font-size: 14px;
      font-weight: 400;
      font-family: ${theme.fonts.primary};
      text-transform: uppercase;
      ${theme.below.lg} {
        font-size: 12px;
      }
    }
  }

  [data-flight-dropdown] {
    margin-bottom: 0 !important;
    border: none !important;
  }

  [data-flight-dropdown-items] {
    border: 1px solid ${theme.colors.border} !important;
    min-width: 220px;
  }

  [data-flight-dropdown-item] {
    display: flex !important;
    justify-content: space-between !important;
    font-size: 12px !important;
  }

  svg {
    width: 18px;
    height: 13px;
    margin-right: 5px;
    margin-left: 0 !important;
    ${theme.below.lg} {
      width: 12px;
      height: 12px;
    }
  }
`;

const Badge = styled('div')`
  position: absolute;
  display: block;
  top: 12px;
  background: ${theme.colors.primary};
  color: white;
  padding: 1px 6px;
  border-radius: 50%;
  right: 8px;
  font-size: 10px;
  z-index: 1;
  line-height: 0.9rem;
  width: 17px;
  height: 17px;

  ${theme.below.lg} {
    top: 8px;
    padding: 1px 5px;
    width: 16px;
    height: 16px;
  }
`;

// const ActiveListFilterWrapper = styled('div')``;

function Filter({ filters, sortOrders, totalProducts }) {
  const topPosition = useHeaderHeight();

  const numOfActiveFilters = useMemo(() => {
    let activeFilters = 0;
    filters.forEach(filter => {
      switch (filter.__typename) {
        case 'ListFilter':
        case 'MultiListFilter':
          if (filter.hasActiveItems) activeFilters++;
          break;
        case 'NumericRangeFilter':
          if (filter.isActive) activeFilters++;
          break;
        case 'BooleanFilter':
          if (filter.value) activeFilters++;
          break;
        default:
          break;
      }
    });

    return activeFilters;
  }, [filters]);

  return (
    <>
      <FilterRow>
        <div className="upper">
          <ButtonWrapper>
            <DrawerTrigger id="filterDrawer" coverStyles={{ top: topPosition }}>
              {({ showTarget }) => (
                <FilterButtonWrapper>
                  <FilterButton
                    showTarget={showTarget}
                    filters={filters}
                    active={numOfActiveFilters > 0 && true}
                  />
                  {numOfActiveFilters > 0 && (
                    <Badge>{numOfActiveFilters}</Badge>
                  )}
                </FilterButtonWrapper>
              )}
            </DrawerTrigger>
            <SortButtonWrapper>
              <SortOrders sortOrders={sortOrders} />
            </SortButtonWrapper>

            {/* <Above breakpoint="lg">
              {matches => matches && <ActiveFilters filters={filters} />}
            </Above> */}
          </ButtonWrapper>

          <ProductNumber>
            {t('{totalProducts} Products', {
              totalProducts: totalProducts
            })}
          </ProductNumber>
        </div>
        {/* <Below breakpoint="lg">
          {matches => matches && <ActiveFilters filters={filters} />}
        </Below> */}
      </FilterRow>

      <DrawerTarget id="filterDrawer">
        {({ hideTarget, isOpen }) => (
          <DrawerWrapper topPosition={topPosition}>
            <Above breakpoint="lg">
              {matches => (
                <Drawer isOpen={isOpen} left size={320}>
                  <FilterDrawer
                    totalproducts={totalProducts}
                    close={hideTarget}
                    filters={filters}
                    sortOrders={sortOrders}
                  />
                </Drawer>
              )}
            </Above>
          </DrawerWrapper>
        )}
      </DrawerTarget>
    </>
  );
}

export default Filter;
